import { render } from "./Gen4.vue?vue&type=template&id=21bef5a6&scoped=true"
import script from "./Gen4.vue?vue&type=script&lang=js"
export * from "./Gen4.vue?vue&type=script&lang=js"

import "./Gen4.vue?vue&type=style&index=0&id=21bef5a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bef5a6"]])

export default __exports__